/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordRequest as ModelsContactChangePasswordRequest } from '../../models/Models/Contact/change-password-request';

export interface V3ContactsMePasswordPut$Xml$Params {
      body?: ModelsContactChangePasswordRequest
}

export function v3ContactsMePasswordPut$Xml(http: HttpClient, rootUrl: string, params?: V3ContactsMePasswordPut$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, v3ContactsMePasswordPut$Xml.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

v3ContactsMePasswordPut$Xml.PATH = '/v3/contacts/me/password';
